import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import './material.css'
import './../../css/nike.css'

class Standings extends Component {
  render() {
    return (
      <div>
        <div
          className="row stripe center-align"
          style={{ height: '100vh', border: 0 }}
        >
          <table
            className="center-align"
            style={{ textAlign: 'center', fontSize: '6vh' }}
          >
            <tr>
              <th style={{ textAlign: 'center' }}>Rank</th>
              <th style={{ textAlign: 'center' }}>Team</th>
              <th style={{ textAlign: 'center' }}>Pts</th>
              <th style={{ textAlign: 'center' }}>GF</th>
              <th style={{ textAlign: 'center' }}>GD</th>
            </tr>
            {this.props.standings.slice(0, 9).map((d, i) => (
              <tr
                className={(d.home ? 'home' : '') + (d.away ? 'away' : '')}
                key={i}
              >
                <td style={{ textAlign: 'center' }}>{i + 1}</td>
                <td style={{ textAlign: 'center' }}>{d.team}</td>
                <td style={{ textAlign: 'center' }}>{d.points}</td>
                <td style={{ textAlign: 'center' }}>{d.gf}</td>
                <td style={{ textAlign: 'center' }}>{d.gd}</td>
              </tr>
            ))}
          </table>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({})

const mapDispatchToProps = (dispatch, ownProps) => ({})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Standings)
)
